'use client';
import React, { FC, memo, ReactNode, PropsWithChildren, useState } from 'react';
import styles from './index.module.scss';
import cls from 'classnames';
import { Pagination } from '@bfe/moly';

export interface Props {
  title?: ReactNode;
  subTitle?: ReactNode;
  pagination?: PaginationOptions;
  noFooter?: boolean;
  noFooterPadding?: boolean;
  noHeaderPadding?: boolean;
  isPc: boolean;
  isHistory?: boolean;
}

interface PaginationOptions {
  total?: number;
  pageSize?: number;
  current?: number;
  onChange?: (params) => void;
}

export const defaultPaginationProps = {
  pageSize: 10,
  current: 1,
};

export const usePagination = (options: PaginationOptions) => {
  const [page, setPage] = useState<number>(
    options.current || defaultPaginationProps.current
  );

  const mergedOptions = {
    ...defaultPaginationProps,
    ...options,
  };

  const handleChange = (pageNo) => {
    setPage(pageNo);

    options?.onChange?.({ current: pageNo, pageSize: mergedOptions.pageSize });
  };

  return {
    ...mergedOptions,
    current: page,
    onChange: handleChange,
  };
};

const ProjectList: FC<PropsWithChildren<Props>> = ({
  title,
  subTitle,
  children,
  pagination,
  noFooter,
  noFooterPadding,
  noHeaderPadding,
  isPc,
  isHistory = false,
}) => {
  const paginationProps = usePagination(pagination || {});

  return (
    <div
      className={cls(styles.projectList, {
        [styles.noFooterPadding]: noFooterPadding,
        [styles.noHeaderPadding]: noHeaderPadding,
        [styles.pt0]: isHistory
      })}
    >
      <div className="container-box">
        <div className={styles.header}>
          <div className={styles.title}>
            {!isPc && <span className={styles.linerLeft} />}
            {title}
            {!isPc && <span className={styles.linerRight} />}
          </div>
          <div className={styles.subTitle}>{subTitle}</div>
        </div>
        <div className={styles.content}>{children}</div>
        {noFooter ? null : (
          <div className={styles.footer}>
            <Pagination {...paginationProps} />
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(ProjectList);
